/*
  COTANTIN：data-open-chat の付いたリンクで Gorgias のチャットを開く。
  - href にはお問い合わせページ（/pages/contact）を入れておく。Gorgias が読み込めていないとき・JS が動かないときはそちらへ移動する
  - お買い物ガイド 5 本（ページ本文の <script>）と同じ処理を、テーマのファイルに切り出したもの
  - 2026-10-01：Gorgias は後から読み込むので、まだ読まれていなければ読み込んでから開く（snippets/cotantin-gorgias-loader）
  - 2026-10-11：リンク以外のボタンからも使えるように window.ctOpenChat(fallbackHref) を出す（スタイルシミュレーターの「チャットで相談する」）。
    開けないときは fallbackHref へ移動する
*/
(function () {
  if (window.__ctChat) return;
  window.__ctChat = true;

  var open = function (chat, fallbackHref) {
    var fallback = function () { if (fallbackHref) window.location.href = fallbackHref; }; // 開けないときは fallbackHref へ
    try {
      if (!chat) { fallback(); return; }
      // 準備前の GorgiasChat は init 以外を読むとエラーになる。先に init を待ってから open を読む。
      // init が終わると window.GorgiasChat が本物に替わるので、open は window から読み直す（Gorgias のドキュメントの形）
      if (typeof chat.init === 'function') {
        chat.init().then(function () { window.GorgiasChat.open(); }).catch(fallback);
      } else if (typeof chat.open === 'function') {
        chat.open();
      } else {
        fallback();
      }
    } catch (e) {
      fallback();
    }
  };

  // Gorgias はページを開いてから後で読み込む（snippets/cotantin-gorgias-loader）。まだなら読み込んでから開く
  window.ctOpenChat = function (fallbackHref) {
    if (window.GorgiasChat) { open(window.GorgiasChat, fallbackHref); return; }
    if (typeof window.ctLoadGorgias !== 'function') { open(null, fallbackHref); return; }
    window.ctLoadGorgias().then(function () { open(window.GorgiasChat, fallbackHref); });
  };

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-open-chat]');
    if (!link) return;
    if (!window.GorgiasChat && typeof window.ctLoadGorgias !== 'function') return; // そのまま href へ
    event.preventDefault();
    window.ctOpenChat(link.href);
  });
})();
